<template>
    <div class="orders-carousel-component">
        <carousel
            :pagination-enabled="true"
            :per-page-custom="[[0, 1], [768, 2], [1145, 3]]"
            :min-swipe-distance="40"
            pagination-active-color="#8071F3"
            :navigation-enabled="true"
            pagination-color="rgba(128, 113, 243, 0.4)"
            :pagination-size="8"
            :loop="true"
            class="orders-carousel"
            ref="orders-carousel"
            @page-change="ordersCarouselPageChange"
        >
            <slot
                :callbackRegTurnkey="callbackRegTurnkey"
                :callbackRegFast="callbackRegFast"
                :callbackRegPaidSocial="callbackRegPaidSocial"
                :callbackRegPaidDocs="callbackRegPaidDocs"
                :callbackReportMoneyTransfer="callbackReportMoneyTransfer"
                :callbackOpenAccountNotify="callbackOpenAccountNotify"
                :callbackTrader="callbackTrader"
                :callbackTraderPlus="callbackTraderPlus"
                :callbackOneDayDeclaration="callbackOneDayDeclaration"
                :callbackSuccessfulSolution="callbackSuccessfulSolution"
                :callbackVipConsultation="callbackVipConsultation"
                :callbackFreeConsultation="callbackFreeConsultation"
                :callbackExpeditedReturn="callbackExpeditedReturn"
                :scrollToRega="scrollToRega"
            ></slot>
        </carousel>
        <div class="space-plug" v-show="false"></div>
    </div>
</template>

<script>
import {api} from "../js/api";
import orderHelper from '../js/utils/orderHelper';
import { Carousel } from 'vue-carousel';

export default {
    name: 'OrdersCarousel',

    components: {
        Carousel
    },

    mixins: [
        orderHelper
    ],

    data () {
        return {
            orderList: [],
        }
    },

    methods: {
        removeOrderHighlight() {
            const oldHighlightedBlock = document.querySelector('.orders-carousel-component .item.highlight');
            if (oldHighlightedBlock) {
                oldHighlightedBlock.classList.remove('highlight');
            }
        },

        highlightOrder(orderBlock, openShortReg) {
            this.removeOrderHighlight();
            orderBlock.classList.add('highlight');

            if (openShortReg) {
                this.hideShortReg();
                orderBlock.classList.add('opened-shortreg');
            }
        },

        scrollToElement(element) {
            if (element) {
                requestAnimationFrame(() => {
                    const yOffset = -document.querySelector('#header').offsetHeight;
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

                    window.scrollTo({top: y, behavior: 'smooth'});
                });
            }
        },

        scrollToOrder(selector, openShortReg = false) {
            const targetBlock = document.querySelector(selector);

            if (!targetBlock || !targetBlock.classList.contains('item')) {
                return;
            }

            const orderBlocks = document.querySelectorAll('.orders-carousel-component .item');
            for (let i = 0; i < orderBlocks.length; i++) {
                if (orderBlocks[i] === targetBlock) {
                    this.setOrdersSlide(i);
                    this.removeOrderHighlight();
                    this.scrollToElement(targetBlock);
                    requestAnimationFrame(() => {
                        this.highlightOrder(targetBlock, openShortReg);
                    });
                    break;
                }
            }
        },

        scrollToRega() {
            const rega = document.querySelector('.submain__rega');
            const traderRega = document.querySelector('.trader-rega');
            const vnRega = document.querySelector('.main-rega-block');

            rega && this.scrollToElement(rega);
            traderRega && this.scrollToElement(traderRega);
            vnRega && this.scrollToElement(vnRega);
        },

        ordersCarouselPageChange() {
            this.removeOrderHighlight();
        },

        callbackRegTurnkey() {
            this.checkOrders()
            .then(() => {
                //document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'home_reg_turnkey' }}));
                this.handleInitCreateOrder(29);
            });
        },

        callbackFreeConsultation() {
            this.checkOrders()
            .then(() => {
                this.handleInitCreateOrder(39);
            });
        },

        callbackRegFast() {
            this.checkOrders()
            .then(() => {
                //document.dispatchEvent(new CustomEvent('pushGoal', { detail: {'goal': 'home_reg_fast' }}));
                this.handleInitCreateOrder(40);
            });
        },

        callbackRegPaidSocial() {
            this.checkOrders()
            .then(() => {
                sessionStorage.setItem('serviceId', 34);
                this.handleInitCreateOrder(34);
            });
        },

        callbackRegPaidDocs() {
            this.checkOrders()
            .then(() => {
                this.handleInitCreateOrder(35);
            });
        },

        callbackReportMoneyTransfer() {
            this.checkOrders()
            .then(() => {
                sessionStorage.setItem('serviceId', 25);
                this.handleInitCreateOrder(25);
            });
        },

        callbackOpenAccountNotify() {
            this.checkOrders()
            .then(() => {
                sessionStorage.setItem('serviceId', 27);
                this.handleInitCreateOrder(27);
            });
        },

        callbackTrader() {
            this.checkOrders()
            .then(() => {
                sessionStorage.setItem('serviceId', '23');
                this.handleInitCreateOrder(23);
            })
        },

        callbackTraderPlus() {
            this.checkOrders()
            .then(() => {
                sessionStorage.setItem('serviceId', '8');
                this.handleInitCreateOrder(8);
            })
        },

        callbackOneDayDeclaration(){
            this.checkOrders()
            .then(() => {
                sessionStorage.setItem('serviceId', '37');
                this.handleInitCreateOrder(37);
            })
        },

        callbackSuccessfulSolution() {
            this.checkOrders()
            .then(() => {
                sessionStorage.setItem('serviceId', '38');
                this.handleInitCreateOrder(38);
            })
        },

        callbackVipConsultation() {
            this.checkOrders()
            .then(() => {
                sessionStorage.setItem('serviceId', '36');
                this.handleInitCreateOrder(36);
            })
        },

        callbackExpeditedReturn() {
            this.checkOrders()
            .then(() => {
                sessionStorage.setItem('serviceId', '41');
                this.handleInitCreateOrder(41);
            })
        },

        handleInitCreateOrder(serviceId) {
            this.initCreateOrder(serviceId, this.orderList);
        },

        checkOrders() {
            return api.get('/order/list')
            .then(res => {
                this.orderList = res.data;
            }).catch((error) => {
                console.log(error);
            });
        },

        setOrdersSlide(index) {
            const ordersCarousel = this.$refs['orders-carousel'];
            ordersCarousel && ordersCarousel.goToPage(Math.floor(index / ordersCarousel._computedWatchers.breakpointSlidesPerPage.value));
        }
    }
}
</script>